export default function (value, amountOnly) {
	if (value || value === 0 || value === '0') {
		var price = (Number(value)/100).toFixed(2);
		if (price < 0) {
			let creditAmount = Math.abs(price);
			if (amountOnly) {
				return creditAmount;
			} else { 
				return '(CR) £'+creditAmount;
			}
		} else {
			if (amountOnly) {
				return price;
			} else {
				return '£'+price;
			}
		}
	}
}
